// Registers the portal service worker. Idempotent — safe to call on every
// portal mount. Only registers when running on the affiliate portal to avoid
// caching the internal CRM.
export function registerPortalSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Only run in secure contexts (HTTPS or localhost) — SW requirement.
  if (!window.isSecureContext) return;

  // Register once — repeated calls hit navigator.serviceWorker.getRegistration()
  // and no-op. We defer to `load` so we don't compete with the initial paint.
  const start = () => {
    navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .then((reg) => {
        // Nudge a waiting SW to take over immediately so a refresh isn't required
        // after we ship a new build.
        if (reg.waiting) reg.waiting.postMessage("SKIP_WAITING");
        reg.addEventListener("updatefound", () => {
          const w = reg.installing;
          if (!w) return;
          w.addEventListener("statechange", () => {
            if (w.state === "installed" && navigator.serviceWorker.controller) {
              w.postMessage("SKIP_WAITING");
            }
          });
        });
      })
      .catch(() => {
        /* offline / blocked — silent */
      });
  };
  if (document.readyState === "complete") start();
  else window.addEventListener("load", start, { once: true });
}
